import { Controller } from "@hotwired/stimulus"

// Light / dark theme toggle. The current theme lives in the `theme` cookie so
// the server can stamp <html data-theme> before first paint (no flash). This
// controller flips the attribute + cookie instantly on click and swaps the
// sun/moon icons.
export default class extends Controller {
  static targets = ["light", "dark"]

  connect() {
    this.sync()
  }

  toggle() {
    const next = this.current() === "dark" ? "light" : "dark"
    document.documentElement.setAttribute("data-theme", next)
    document.cookie = `theme=${next};path=/;max-age=31536000;samesite=lax`
    this.sync()
  }

  current() {
    return document.documentElement.getAttribute("data-theme") === "dark" ? "dark" : "light"
  }

  sync() {
    const dark = this.current() === "dark"
    if (this.hasLightTarget) this.lightTarget.classList.toggle("hidden", dark)
    if (this.hasDarkTarget) this.darkTarget.classList.toggle("hidden", !dark)
  }
}
